import type { Recipient, SearchRecipient } from '../../types/Recipient';
import { capitalizeFirstLetter } from '../../helpers';
import { RecipientRole } from '../enums/recipient-role';
import { t } from '../../helpers/translation.helper';

export function getTranslatedRole(role: RecipientRole | string) {
  switch (role) {
    case RecipientRole.CC:
      return t('cc');
    case RecipientRole.Signer:
      return t('signer');
    case RecipientRole.ExternalApprover:
      return t('external_approver');
    case RecipientRole.Approver:
    case RecipientRole.InternalApproverAPIFallback:
      return t('internal-approver');
    default:
      return '';
  }
}

export function isInternalApprover(role: RecipientRole | string) {
  return [RecipientRole.Approver, RecipientRole.InternalApproverAPIFallback].includes(
    role as RecipientRole
  );
}

export function isApprover(role: RecipientRole | string) {
  return isInternalApprover(role) || role === RecipientRole.ExternalApprover;
}

export function getRecipientFullName(recipient: Partial<Recipient>): string {
  if (!recipient) {
    return '';
  }
  return recipient.fullName || `${recipient.firstName || ''} ${recipient.lastName || ''}`.trim();
}

// This should  only allow valid email addresses
export function getRecipientDataFromEmail(email: string): SearchRecipient {
  //This is used in case you passed invalid email address
  if (!email || email.indexOf('@') === -1 || email.split('@')[0].trim() === '') {
    return {
      email, // Return the provided email as-is, even if invalid
    };
  }

  const names: string[] = email

    .split('@')[0]
    .split('.')
    .map(name => capitalizeFirstLetter(name));

  const firstName = names[0] || '';
  const lastName = names.slice(1).join(' ').trim() || '';
  const fullName = `${names.join(' ')}`.trim();

  return {
    firstName,
    lastName,
    fullName,
    email,
  };
}
